<template>
  <div class="PieLegendConfiger">
    <div class="p-lable">
      <span>legend开关</span>
      <el-switch
        @change="handleChange"
        v-model="isShow"
        size="mini"
        active-color="#6f6ff5"
        inactive-color="#55597b"
      >
      </el-switch>
    </div>

  </div>
</template>
<script>
export default {
  name: 'PieLegendConfiger',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      isShow: false,

    };
  },
  mounted() {
    /* 获取初始值 */
    this.init();
  },
  methods: {
    init() {
      this.isShow = this.propertyData.PieLegendConfiger.value;

    },
    handleChange() {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.isShow,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.PieLegendConfiger {
  :deep().el-switch {
    margin: auto 0;
    .el-switch__core {
      background: #55597b;
      border: none;
      height: 10px;
      width: 30px !important;
      .el-switch__action {
        top: -2px;

        background: #c9cae5;

        width: 14px;
        height: 14px;
      }
    }
    &.is-checked {
      .el-switch__core {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        .el-switch__action {
          left: 100%;
          background: #ffffff;
          margin-left: -14px;
        }
      }
    }
  }

  width: 100%;
  box-sizing: border-box;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 43px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .p-ChartsAnimationConfiger-wrap {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 35px;
    padding: 0 15px;
    .el-input {
      width: 40px;
    }
    :deep() input {
      color: #ffffff;
      height: 20px;
      background: #191b23;
      border-radius: 0;
      padding: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }

    .p-input {
      height: 35px;
      display: flex;
      align-items: center;
      & > span {
        margin-left: 10px;
        font-size: $property-attributes-size;
      }
    }
    .p-config {
      color: $property-attributes-color;
      height: 35px;
      line-height: 35px;
      font-size: $property-attributes-size;
    }
  }
}
</style>
